export enum PropertyManagerType {
    AD = 'Ad',
    TEMPLATE = 'Template',
    CREATIVE = 'Creative',
}

export function isPropertyManagerType(x: any): x is PropertyManagerType {
    return (
        typeof x === 'string' &&
        (x === PropertyManagerType.AD ||
            x === PropertyManagerType.TEMPLATE ||
            x === PropertyManagerType.CREATIVE)
    );
}

export function ifPropertyManagerType(x: any): PropertyManagerType | undefined {
    return isPropertyManagerType(x) ? x : undefined;
}
